module.exports = __webpack_public_path__ + "static/media/pexels-expect-best-323705.348b78e0.jpg";